

import { db } from "../../config/firebase";
import { collection, addDoc, getDoc, query, where, limit, getDocs, doc, updateDoc, orderBy, arrayUnion, Timestamp } from 'firebase/firestore'

const toMillis = (value) => {
    if (!value) return value;
    if (typeof value === 'number') return value;
    if (typeof value?.toDate === 'function') return value.toDate().getTime();
    if (typeof value?.seconds === 'number') return value.seconds * 1000;
    return value;
};

const normalizeEvent = (event) => {
    if (!event) return event;
    return {
        ...event,
        startDate: toMillis(event.startDate),
        endDate: toMillis(event.endDate),
        createdAt: toMillis(event.createdAt),
        createDate: toMillis(event.createDate),
        updateDate: toMillis(event.updateDate),
        updatedAt: toMillis(event.updatedAt),
    };
};

const normalizeMatching = (matching) => {
    if (!matching) return matching;
    return {
        ...matching,
        startDate: toMillis(matching.startDate),
        endDate: toMillis(matching.endDate),
        createdAt: toMillis(matching.createdAt),
        createDate: toMillis(matching.createDate),
        updateDate: toMillis(matching.updateDate),
        updatedAt: toMillis(matching.updatedAt),
    };
};

const normalizeMeetdesk = (desk) => {
    if (!desk) return desk;
    return {
        ...desk,
        availabilityStart: toMillis(desk.availabilityStart),
        availabilityEnd: toMillis(desk.availabilityEnd),
        availableStart: toMillis(desk.availableStart),
        availableEnd: toMillis(desk.availableEnd),
        startDate: toMillis(desk.startDate),
        endDate: toMillis(desk.endDate),
        createdAt: toMillis(desk.createdAt),
        createDate: toMillis(desk.createDate),
        updateDate: toMillis(desk.updateDate),
        updatedAt: toMillis(desk.updatedAt),
    };
};

// 🔹 Bugünün 00:00:00 zamanı (yerel saat diliminde)
const today = new Date();
today.setHours(0, 0, 0, 0);

const getEvent = async (eventId) => {
    const colRef = await collection(db, 'meetings');
    const q = query(
        colRef,
        where("meetingId", "==", eventId),
        where("isactivity", "==", true),
        where("private", "==", false),
        where("state", "==", true),
        where("businessId", "==", ""),
        limit(1)
    );
    const querySnapshot = await getDocs(q);
    let dizi = [];
    querySnapshot.forEach((doc) => {
        dizi.push({ ...doc.data(), id: doc.id })
    });
    return normalizeEvent(dizi[0]);
}


const getEventUsers = async (eventId) => {
    const colRef = collection(db, "users");

    const q = query(
        colRef,
        where("meetings", "array-contains", eventId),
        orderBy("name")
    );

    const querySnapshot = await getDocs(q);

    const users = querySnapshot.docs.map((doc) => {
        const data = doc.data();

        return {
            id: doc.id, // Firestore doc id
            userId: data.userId || doc.id,
            name: data.name || "",
            surName: data.surName || "",
            userEmail: data.userEmail || "",
            country: data.country || "",
            businessName: data.businessName || "",
            businessPosition: data.businessPosition || "",
            sectoren: data.sectoren || "",
            sectortr: data.sectortr || "",
        };
    });

    return users;
};


const joinEvent = async (eventId, userId) => {
    const docRefUser = await doc(db, 'users', userId);
    const docRefMeeting = await doc(db, 'meetings', eventId);
    try {
        await updateDoc(docRefMeeting, {
            users: arrayUnion(userId)
        });
        await updateDoc(docRefUser, {
            meetings: arrayUnion(eventId)
        });
        console.log('Diziye yeni eleman başarıyla eklendi.');
    } catch (error) {
        console.error('Diziye eleman eklerken hata oluştu:', error);
    }
    return { status: "true" };
}

// Matchings (B2B slot reservations)
const getMatchingsByMeeting = async (meetingId) => {
    const colRef = await collection(db, 'matchings');
    const q = query(
        colRef,
        where('meetingId', '==', meetingId),
        orderBy('startDate', 'asc'),
    );
    const querySnapshot = await getDocs(q);
    const items = [];
    querySnapshot.forEach((doc) => {
        items.push({ ...doc.data(), id: doc.id });
    });
    return items.map(normalizeMatching);
}


const createMatching = async (matchingData) => {
    const colRef = await collection(db, 'matchings');
    const docRef = await addDoc(colRef, {
        ...matchingData,
        createDate: Timestamp.fromDate(new Date()),
        state: matchingData.state ?? true,
        status: matchingData.status ?? true,
    });
    const docSnap = await getDoc(docRef);
    const refUpdate = await doc(db, 'matchings', docSnap.id);
    await updateDoc(refUpdate, { matchingId: docSnap.id });
    return normalizeMatching({ ...docSnap.data(), matchingId: docSnap.id, id: docSnap.id });
}


const getMeetDesks = async (eventId) => {
    const userId = JSON.parse(localStorage.getItem('user')).uid;
    const colRef = await collection(db, 'meetings', eventId, 'meetdesks');
    const q = query(
        colRef,
        orderBy('meetdeskId'),
    );
    const querySnapshot = await getDocs(q);
    let dizi = [];
    querySnapshot.forEach((doc) => {
        dizi.push({ ...doc.data(), id: doc.id })
    });
    // Update meeting doc with aggregated desk users
    try {
        const deskUsers = Array.from(new Set(
            dizi.flatMap((desk) => {
                if (Array.isArray(desk?.users) && desk.users.length > 0) {
                    return desk.users.filter(Boolean).map(String);
                }
                if (desk?.userId) return [String(desk.userId)];
                return [];
            })
        ));
        await updateDoc(doc(db, 'meetings', eventId), { deskusers: deskUsers });
    } catch (error) {
        console.warn('Failed to update deskusers:', error);
    }
    return dizi.map(normalizeMeetdesk);
}


const getB2BMeetings = async (eventId, userId) => {
    const colRef = await collection(db, 'meetings');
    const q = query(
        colRef,
        where("topMeetingId", "==", eventId),
        where("isbtob", "==", true),
        where("state", "==", true),
        where("users", "array-contains", userId),
        orderBy('startDate'),
    );
    const querySnapshot = await getDocs(q);
    let dizi = [];
    querySnapshot.forEach((doc) => {
        dizi.push({ ...doc.data(), id: doc.id })
    });
    return dizi.map(normalizeEvent);
}


const getB2BSessions = async (eventId) => {
    const colRef = await collection(db, 'meetings');
    const q = query(
        colRef,
        where("topmeetingid", "==", eventId),
        where("isbtobsession", "==", true),
        where("state", "==", true),
        orderBy('startDate'),
    );
    const querySnapshot = await getDocs(q);
    let dizi = [];
    querySnapshot.forEach((doc) => {
        dizi.push({ ...doc.data(), id: doc.id })
    });
    if (dizi.length > 0) return dizi.map(normalizeEvent);
    const fallbackQuery = query(
        colRef,
        where("topmeetingid", "==", eventId),
        where("isbtobsession", "==", true),
        orderBy('startDate'),
    );
    const fallbackSnap = await getDocs(fallbackQuery);
    const fallback = [];
    fallbackSnap.forEach((doc) => {
        fallback.push({ ...doc.data(), id: doc.id })
    });
    return fallback.map(normalizeEvent);
}


const toQueryDate = (value) => {
    if (!value) return null;
    if (value instanceof Date) return value;
    if (typeof value === 'number') return Timestamp.fromMillis(value);
    if (typeof value?.toDate === 'function') return value; // Firestore Timestamp
    if (typeof value?.seconds === 'number') return Timestamp.fromMillis(value.seconds * 1000);
    return value;
};

const getB2BMatchings = async (eventId, range = {}) => {
    const colRef = await collection(db, 'matchings');
    const rangeStart = toQueryDate(range.startDate);
    const rangeEnd = toQueryDate(range.endDate);
    const q = query(
        colRef,
        where('topmeetingid', '==', eventId),
        where("state", "==", true),
        ...(rangeStart ? [where('endDate', '>=', rangeStart)] : []),
        ...(rangeEnd ? [where('endDate', '<=', rangeEnd)] : [where('endDate', '>=', today)]),
        orderBy('endDate'),
    );
    const querySnapshot = await getDocs(q);
    const items = [];
    querySnapshot.forEach((doc) => {
        items.push({ ...doc.data(), id: doc.id });
    });
    return items.map(normalizeMatching);
}


const getMyB2BMatchings = async (eventId, userId) => {
    const colRef = await collection(db, 'matchings');
    const q = query(
        colRef,
        where('topmeetingid', '==', eventId),
        where("state", "==", true),
        where('users', 'array-contains-any', [userId]),
        orderBy('startDate', 'asc'),
    );
    const querySnapshot = await getDocs(q);
    const items = [];
    querySnapshot.forEach((doc) => {
        items.push({ ...doc.data(), id: doc.id });
    });
    return items.map(normalizeMatching);
}


const cancelMyB2BMatching = async (matchingId, meetingId) => {
    const docRefMatching = await doc(db, 'matchings', matchingId);
    try {
        await updateDoc(docRefMatching, {
            users: [],
            state: false,
        });
        console.log('matchings update');
    } catch (error) {
        console.error('matchings update:', error);
    }
    return { status: "true" };
}





const eventService = {
    getEvent,
    getEventUsers,
    joinEvent,
    getMatchingsByMeeting,
    createMatching,
    getMeetDesks,
    getB2BMeetings,
    getB2BSessions,
    getB2BMatchings,
    getMyB2BMatchings,
    cancelMyB2BMatching,
}

export default eventService
